import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface ImpactoAtendido {
  id: number;
  descripcion: string;
}

export interface MedidaManejo {
  id: number;
  medida_manejo: string;
  tipo_medida: string;
  impactos_atendidos_ids: number[];
  evidencias: any[];
  ejecucion_periodo: string;
  parametro_control_descripcion?: string;
  parametro_control_valor?: string;
  valor_referencia_descripcion?: string;
  valor_referencia_valor?: string;
  cumplimiento_si_no?: string;
  indicadores?: Indicador[];
}

export interface Indicador {
  meta_descripcion: string;
  periodicidad_verificacion?: string;
  porcentaje_cumplimiento?: string;
  porcentaje_avance_programado?: string;
  porcentaje_avance_fecha?: string;
  observaciones?: string;
}

export interface Observacion {
  id: number;
  descripcion: string;
}

export interface DatosReporte {
  obligacion: any;
  planManejo: any;
}

export const useReporteSST = (obligacionId?: string) => {
  const [loading, setLoading] = useState(false);
  const [datosReporte, setDatosReporte] = useState<DatosReporte | null>(null);
  const { toast } = useToast();

  const cargarDatosReporte = async (id: string) => {
    setLoading(true);
    try {
      // Cargar obligación
      const { data: obligacion, error: errorObligacion } = await supabase
        .from('obligaciones_ambientales')
        .select('*')
        .eq('id', id)
        .single();

      if (errorObligacion) throw errorObligacion;

      // Cargar plan de manejo más reciente (sin filtrar por user_id, las RLS se encargan)
      const { data: planesManejo, error: errorPlan } = await supabase
        .from('planes_manejo')
        .select('*')
        .eq('obligacion_id', id)
        .order('created_at', { ascending: false });

      if (errorPlan) throw errorPlan;

      // Tomar el primer plan (el más reciente)
      const planManejo = planesManejo && planesManejo.length > 0 ? planesManejo[0] : null;

      setDatosReporte({
        obligacion,
        planManejo,
      });
    } catch (error: any) {
      console.error('Error cargando datos del reporte:', error);
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos del reporte',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (obligacionId) {
      cargarDatosReporte(obligacionId);
    }
  }, [obligacionId]);

  return {
    loading,
    datosReporte,
    cargarDatosReporte,
  };
};
